import { Link } from "react-router-dom";
import { DomainIcon } from "./HomeIcons";
import type { HomeSolutionTeaser } from "./home-content";

type Locale = "fr" | "en";

/**
 * Approved Home Solutions card presentation.
 * Visual design locked for EDU/RH/MinePortal — additional products inherit the same system.
 */
export function SolutionCard({
  teaser,
  locale,
  limitedLabel,
}: {
  teaser: HomeSolutionTeaser;
  locale: Locale;
  limitedLabel: string;
}) {
  const en = locale === "en";

  return (
    <article className={`pep-home-solution pep-home-solution--${teaser.slug}`}>
      <div className="pep-home-solution__media">
        <img
          className="pep-home-solution__img"
          src={teaser.imageSrc}
          alt={en ? teaser.imageAltEn : teaser.imageAltFr}
          width={768}
          height={512}
          loading="lazy"
          decoding="async"
          style={{ objectPosition: teaser.objectPosition }}
        />
        <span
          className={`pep-home-solution__badge pep-home-solution__badge--${teaser.slug}`}
          aria-hidden="true"
        >
          <DomainIcon name={teaser.icon} />
        </span>
        {teaser.availability === "limited" ? (
          <span className="pep-home-solution__status">{limitedLabel}</span>
        ) : null}
      </div>
      <div className="pep-home-solution__body">
        <p className={`pep-home-solution__label pep-home-solution__label--${teaser.slug}`}>
          {en ? teaser.labelEn : teaser.labelFr}
        </p>
        <h3 className="pep-home-solution__title">{en ? teaser.titleEn : teaser.titleFr}</h3>
        <p className="pep-home-solution__line">{en ? teaser.lineEn : teaser.lineFr}</p>
        <Link className="pep-home-text-link pep-home-solution__cta" to={`/products/${teaser.slug}`}>
          {en ? teaser.ctaEn : teaser.ctaFr} →
        </Link>
      </div>
    </article>
  );
}
